import { ApiHelper } from '@nykaa/utils/network';
import { logger } from '@nykaa/logger';

import { ROUTES, getSeoUrl } from 'shared/api/urls';

export const getBreadCrumbs = async (id: string) => {
  const url = getSeoUrl(ROUTES.BREADCRUMBS);
  const domain = process.env.PLATFORM;
  try {
    const { data } = await ApiHelper(`${url}?id=${id}&domain=${domain}`, 'get');
    return data?.response;
  } catch (error) {
    logger.error(error, 'Error fetching in breadcrumbs');
    return null;
  }
};
